module.exports = __webpack_public_path__ + "static/media/icon-percentage.7a34ef12.svg";